import React from 'react';
import { Modal, Typography, Input } from 'antd';
import { useFormContext } from 'react-hook-form';
// Types
import { GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items } from 'api/campaignV2/types/GetCampaignOffers';
import {
  DeliverableReviewAction,
  CBDeliverableItemType,
} from 'api/graphql-global-types';
// Components
import { DeliverableReviewData } from '../../TimelineDeliverablesReviewForm';
// Styles
import styles from './RejectFeedbackModal.module.scss';

const { Text } = Typography;
const { TextArea } = Input;

type RejectFeedbackModalProps = {
  item: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items;
  onClose: () => void;
};

const RejectFeedbackModal: React.FC<RejectFeedbackModalProps> = ({
  item,
  onClose,
}) => {
  const methods = useFormContext<DeliverableReviewData>();

  const handleSubmit = () => {
    if (item.type === CBDeliverableItemType.COPY) {
      methods.setValue('postReview.action', DeliverableReviewAction.REJECT);
    } else {
      const currentReviews = methods.getValues('contentReviews');
      const existingIndex = currentReviews.findIndex(
        (review) => review.deliverableItemId === item.id
      );
      if (existingIndex >= 0) {
        currentReviews[existingIndex].action = DeliverableReviewAction.REJECT;
        methods.setValue('contentReviews', [...currentReviews]);
      }
    }
    onClose();
  };

  return (
    <Modal
      title="Provide Feedback for Rejection"
      visible={true}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Submit Feedback"
      className={styles.modal}
    >
      <div className={styles.feedbackContainer}>
        <Text className={styles.feedbackDescription}>
          Please provide specific feedback on what needs to be changed for this{' '}
          {item.type === CBDeliverableItemType.COPY
            ? 'post caption'
            : 'content item'}
          .
        </Text>

        <div className={styles.feedbackInput}>
          <Text strong>Feedback:</Text>
          <TextArea
            rows={6}
            placeholder="Please provide specific feedback on what needs to be changed..."
            onChange={(e) => {
              if (item.type === CBDeliverableItemType.COPY) {
                methods.setValue('postReview.feedback', e.target.value);
              } else {
                const currentReviews = methods.getValues('contentReviews');
                const existingIndex = currentReviews.findIndex(
                  (review) => review.deliverableItemId === item.id
                );
                if (existingIndex >= 0) {
                  currentReviews[existingIndex].feedback = e.target.value;
                  methods.setValue('contentReviews', [...currentReviews]);
                }
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RejectFeedbackModal;
